import { z } from 'zod';

export const ShortErrorResponseSchema = z.object({
    error: z.string().nullable(),
    error_description: z.string().nullable(),
    account_id: z.number().nullable()
});

export type TShortErrorResponse = z.infer<typeof ShortErrorResponseSchema>;
